export async function generateItinerary({ origin, destination, dates, budget, foodPreferences, numPeople, destinationType }) {
    try {
     const response = await fetch("https://match-scheduler-backend.onrender.com/api/travel-plan", {
      //const response = await fetch("http://localhost:5001/api/travel-plan", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ origin, destination, dates, budget, foodPreferences, numPeople, destinationType }),
      });
  
      if (!response.ok) {
        throw new Error("Failed to fetch itinerary");
      }
  
      const data = await response.json();
      return data.itinerary;
    } catch (error) {
      console.error("Error in generateItinerary:", error);
      throw error;
    }
  }  